import type { ZodTypeAny } from 'zod';

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export interface EndpointDef<
  P extends ZodTypeAny,
  Q extends ZodTypeAny,
  B extends ZodTypeAny,
  R extends ZodTypeAny,
> {
  method: HttpMethod;
  path: string;
  params: P;
  query: Q;
  body: B;
  response: R;
  successStatus?: 200 | 201 | 204;
}

export const defineEndpoint = <
  P extends ZodTypeAny,
  Q extends ZodTypeAny,
  B extends ZodTypeAny,
  R extends ZodTypeAny,
>(
  def: EndpointDef<P, Q, B, R>,
): EndpointDef<P, Q, B, R> => def;
